var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 5.25C12.7175 5.25 12 4.57734 12 3.75C12 2.92266 12.7175 2.25 13.6 2.25C14.4825 2.25 15.2 2.92266 15.2 3.75C15.2 4.57734 14.4825 5.25 13.6 5.25ZM2.4 5.25C1.5175 5.25 0.8 4.57734 0.8 3.75C0.8 2.92266 1.5175 2.25 2.4 2.25C3.2825 2.25 4 2.92266 4 3.75C4 4.57734 3.2825 5.25 2.4 5.25ZM1.6 6H3.2C3.64 6 4.0375 6.16641 4.3275 6.43594C3.32 6.95391 2.605 7.88906 2.45 9H0.8C0.3575 9 0 8.66484 0 8.25V7.5C0 6.67266 0.7175 6 1.6 6ZM8 6C6.4525 6 5.2 4.82578 5.2 3.375C5.2 1.92422 6.4525 0.75 8 0.75C9.5475 0.75 10.8 1.92422 10.8 3.375C10.8 4.82578 9.5475 6 8 6ZM6.08 6.75H6.2875C6.8075 6.98438 7.385 7.125 8 7.125C8.615 7.125 9.19 6.98438 9.7125 6.75H9.92C11.51 6.75 12.8 7.95938 12.8 9.45V10.125C12.8 10.7461 12.2625 11.25 11.6 11.25H4.4C3.7375 11.25 3.2 10.7461 3.2 10.125V9.45C3.2 7.95938 4.49 6.75 6.08 6.75ZM11.6725 6.43594C11.9625 6.16641 12.36 6 12.8 6H14.4C15.2825 6 16 6.67266 16 7.5V8.25C16 8.66484 15.6425 9 15.2 9H13.5525C13.395 7.88906 12.68 6.95391 11.6725 6.43594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.3bd230c05e783bcb3797ab7782fe475e.svg";
export { ForwardRef as ReactComponent };